<!--
 * @Author: guoguo ybbhai@hotmail.com
 * @Date: 2023-09-25 16:26:30
 * @LastEditors: guoguo ybbhai@hotmail.com
 * @LastEditTime: 2023-11-24 11:23:01
 * @FilePath: \web\src\components\Home.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <el-container class="home-container">
    <!-- 时间 -->
    <el-row class="welcome">
      <span>欢迎! &nbsp&nbsp今天是{{ timeInfo.year }}年{{ timeInfo.month + 1 }}月{{ timeInfo.day }}日 </span>
      <span style="margin-left: 18px">星期{{ week2 }} </span>
      <span style="margin-left: 18px">当前时间 {{ timeInfo.hours }}: {{ timeInfo.minutes }}: {{ timeInfo.secondes }} </span>
    </el-row>
    <!-- 主页头部 -->
    <el-header>
      <div style="padding-left: 20%;">
        <a href="/">
          <img style="width: 117px; height: 117px;" src="../assets/images/logo.png" alt="" />
          <img style="width: 450px; height: 80px; margin-bottom: 20px;" src="../assets/images/logo-font.png" alt="" />
        </a>
      </div>
    </el-header>
    <div>
      <!-- 主页导航栏 -->
      <div style="background-color: rgb(64, 112, 186); padding-left: 20%; padding-right: 20%;">
        <el-row>
          <el-menu mode="horizontal" text-color="white"
                    background-color="rgb(64, 112, 186)" class="menu"
                    active-text-color="#000000" :default-active="activeIndex" @select="handleSelect">
            <el-menu-item :key="index" v-for="(item, index) in menuList" :index="item.id.toString()">
              {{ item.name }}
            </el-menu-item>
          </el-menu>
        </el-row>
      </div>
      <el-container>
        <!-- 更变的内容区域 -->
        <el-main class="main">
          <router-view class="box"></router-view>
        </el-main>
      </el-container>
    </div>
    <el-footer class="el-footer">
      <div class="beian">
        @神农公益基金会
        <div>
          <a href="https://beian.miit.gov.cn/" target="_blank">备案号：</a>
          <a href="https://beian.miit.gov.cn/" target="_blank">湘ICP备2024074155号</a>
        </div>
      </div>
    </el-footer>
  </el-container>
</template>

<script>
import { getAll } from '@/api/type.js'
import global from '@/utils/global.js'
import axios from 'axios'
export default {
  name: '',
  data() {
    return {
      timeInfo: {
        currentTime: '',
        year: '',
        month: '',
        day: '',
        week: '',
        hours: '',
        minutes: '',
        secondes: ''
      },
      activeIndex: '1',
      menuList: [],
      menuList2: []
    }
  },
  created() {},
  mounted() {
    this.initTime()
    this.getMenus()
    setInterval(this.initTime, 1000)
    let api3 = global.baseURL + 'news_type/all'
    axios
      .get(api3)
      .then(res => {
        // console.log(res);
        this.menuList2 = res.data.data
      })
      .catch(error => {
        console.log(error)
      })
  },
  watch: {},
  computed: {
    week2() {
      if (this.timeInfo.week == 1) return '一'
      else if (this.timeInfo.week == 2) return '二'
      else if (this.timeInfo.week == 3) return '三'
      else if (this.timeInfo.week == 4) return '四'
      else if (this.timeInfo.week == 5) return '五'
      else if (this.timeInfo.week == 6) return '六'
      else return '日'
    }
  },
  methods: {
    formatterTitle(t) {
      switch (t) {
        case '1':
          return 'index'
        case '22':
          return 'introduce'
        /* case '23':
          return 'zhengce' */
        case '24':
          return 'newsList'
        case '23':
        case '25':
        case '27':
          return 'newsList'
        case '26':
          return 'banShiZhiNan'
        /* case '27':
          return 'kePuFengCai' */
        case '28':
          return 'newsList'
        case '29':
          return 'telephone'
        default:
          return 'newsList'
      }
    },
    getMenus() {
      getAll().then(res => {
        if (res.code == 200) {
          this.menuList = res.data
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      })
    },
    handleSelect(key, keyPath) {
      let name = ''
      for (let item of this.menuList) {
        if (key == item.id) {
          name = item.name
          break
        }
      }

      this.$router.push({
          path: '/home/' + this.formatterTitle(key),
          query: {
            title: this.formatterTitle(key),
            id: key,
            name: name
          }
        })
    },
    // 初始化时间
    initTime() {
      this.timeInfo.currentTime = new Date()
      this.timeInfo.year = this.timeInfo.currentTime.getFullYear()
      this.timeInfo.month = this.timeInfo.currentTime.getMonth()
      this.timeInfo.day = this.timeInfo.currentTime.getDate()
      this.timeInfo.week = this.timeInfo.currentTime.getDay()
      this.timeInfo.hours = this.formattingTime(this.timeInfo.currentTime.getHours())
      this.timeInfo.minutes = this.formattingTime(this.timeInfo.currentTime.getMinutes())
      this.timeInfo.secondes = this.formattingTime(this.timeInfo.currentTime.getSeconds())
    },
    // 格式化时间——两位数
    formattingTime(val) {
      if (val < 10) {
        val = '0' + val
      }
      return val
    }
  }
}
</script>

<style lang="less" scoped>
.home-container {
  height: 100%;
}
.welcome {
  padding: 8px;
  background-color: rgb(2, 64, 135);
  color: rgba(255, 255, 255, 0.562);
  font-size: 10px;
}
.el-header {
  background-color: rgb(1, 72, 153);
}
.el-header {
  height: 120px !important;
  padding: 0 80px 0 0px;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.el-menu {
  .el-menu-item {
    width: 150px;
    font-size: 15px;
    text-align: center;
  }
}
.menu {
  display: flex;
  justify-content: space-between;
}
.el-footer {
  background-color: rgb(85, 81, 82);
}
.main {
  padding: 20px 5px;
}
.el-footer {
  display: flex;
  justify-content: center;
  font-size: 15px;
  color: white;
  text-align: center;
  line-height: 60px;
}
.beian{
  width: 900px;
  display: flex;
  background-color: rgb(85, 81, 82);
  justify-content: space-between;
  a {
    text-decoration: none;
    color: white;
  }
}
.box {
  width: 1200px;
  margin: 0 auto;
}
</style>
